import { render, staticRenderFns } from "./inventory-table.vue?vue&type=template&id=1bb24bc1&"
import script from "./inventory-table.vue?vue&type=script&lang=js&"
export * from "./inventory-table.vue?vue&type=script&lang=js&"
import style0 from "./inventory-table.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardTitle,VCheckbox,VChip,VDataTable,VIcon,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bb24bc1')) {
      api.createRecord('1bb24bc1', component.options)
    } else {
      api.reload('1bb24bc1', component.options)
    }
    module.hot.accept("./inventory-table.vue?vue&type=template&id=1bb24bc1&", function () {
      api.rerender('1bb24bc1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/VaccineViews/VaccineInventoryPage/components/inventory-table.vue"
export default component.exports